module.exports = __webpack_public_path__ + "static/presse-bckg-e775c5d3a005df9c275cc37f04073f4f.jpg";